import styled, { css } from 'styled-components';

export const Label = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.sizes.md};
    white-space: ${({ $noWrap }) => ($noWrap ? 'nowrap' : 'normal')};
  `}
`;

export const Container = styled.div`
  ${({ theme, $disabled }) => css`
    cursor: pointer;
    outline: none;
    border: none;
    background: transparent;
    transition: all 0.3s ease;
    display: flex;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 12px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    background: ${theme.v2.colors.neutral.highPure};
    width: max-content;
    font-family: ${theme.v2.font.family.primary};
  
    ${$disabled && css`
      background: ${theme.v2.colors.neutral.highLight};
      border-color: ${theme.v2.colors.neutral.highLight};
      cursor: not-allowed;
      ${Label} {
        color: ${theme.v2.colors.neutral.lowLight};
      }
    `}

    ${!$disabled && css`
      &:hover {
        background: ${theme.v2.colors.brand.primaryLowLight};
      }
    `}
  `}
`;
